import { AccountBalanceHistoryRequestQuery } from '../../../../../common/model/account/accountBalanceHistoryRequest';
import { AccountBalanceForPeriodViewModel } from '../../../../../common/model/account/accountBalanceForPeriodViewModel';
import { createDataFetchSlice } from '../../../../utils/dataFetch';


export const adminAccountStatisticBalanceSlice = createDataFetchSlice<
    AccountBalanceForPeriodViewModel[],
    Omit<AccountBalanceHistoryRequestQuery, 'offset' | 'count'>
>({ name: 'balance' });
